/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { FraccioService } from '../../../controllers/Fraccio';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGGetFormService } from '../../yasag-get.service';


@Injectable()
export class FraccioReadFormService extends YASAGGetFormService<__model.Fraccio> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
    codi_fraccio: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: FraccioService,
  ) {
    super('FraccioRead', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false, cache = true, only_cache = false): Observable<__model.Fraccio> {
    const result = val => this.service.read(val);
    return this._submit('__model.Fraccio', result, value, cache, only_cache );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.Fraccio> {
    if (submit) {
      this.submit(value);
    }
    return this._listen('__model.Fraccio', value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
